import "./Choose.scss";
import choose1 from "../../assets/choose1.png";
import choose2 from "../../assets/choose2.png";
import check from "../../assets/check.png";

export default function Choose() {
  return (
    <div className="choose spacing">
      <div className="top">
        <div className="left">
          <h2>The Smartest Way to Accept Payments in 2025</h2>
          <p>
            Crypto isn’t a buzzword anymore — it’s how forward-thinking
            businesses are cutting costs and opening doors to a global customer
            base.
          </p>
          <ul>
            <li>
              <img src={check} alt="error" />
              <p>
                Over <span>$4.5 billion</span> in crypto payments were processed
                in Q1 2025 — and it’s only growing.
              </p>
            </li>
            <li>
              <img src={check} alt="error" />
              <p>
                <span>40% of buyers aged 18–35 </span>are choosing crypto at
                checkout this year.
              </p>
            </li>
            <li>
              <img src={check} alt="error" />
              <p>
                Transaction <span> fees are up to 90% lower</span> than
                traditional payment methods.
              </p>
            </li>
            <li>
              <img src={check} alt="error" />
              <p>
                No banks, no borders — just fast, direct payments with zero
                chargebacks.
              </p>
            </li>
          </ul>
          {/* <button>Improve your business</button> */}
        </div>
        <div className="right">
          <img src={choose1} alt="error" />
        </div>
      </div>
      <div className="bottom">
        <div className="left">
          <img src={choose2} alt="error" />
        </div>
        <div className="right">
          <h2>Transparent Fees. No Hidden Costs</h2>
          <p>
            Enjoy fixed, low service commissions that stay the same—no matter
            your transaction volume.
          </p>
          <p>
            Focus on growing your business without worrying about rising costs
            or hidden charges.
          </p>
          <p className="exclude">
            * Blockchain network fees apply separately and may vary based on
            conditions.
          </p>
        </div>
      </div>
    </div>
  );
}
